var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoaching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1820px",
    height: "1820px",
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FB6340",
    strokeWidth: 100,
    cx: 910,
    cy: 910,
    r: 860
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110,1185.00069 L1110,1285 L410,1285 L410,1185.00069 C410,1185.00069 410,985.002075 760,985.002075 C1110,985.002075 1110,1185.00069 1110,1185.00069 M935,710.003977 C935,613.354814 856.649831,535.005187 760,535.005187 C663.350169,535.005187 585,613.354814 585,710.003977 C585,806.653139 663.350169,885.002766 760,885.002766 C856.649831,885.002766 935,806.653139 935,710.003977 M1107,985.002075 C1169.22209,1033.15475 1206.93465,1106.38251 1210,1185.00069 L1210,1285 L1410,1285 L1410,1185.00069 C1410,1185.00069 1410,1003.50195 1107,985.002075 M1060,535.002558 C1025.58437,534.813552 991.925793,545.102892 963.5,564.504983 C1025.77041,651.510558 1025.77041,768.497395 963.5,855.50297 C991.925793,874.905061 1025.58437,885.194401 1060,885.005395 C1156.64983,885.005395 1235,806.653139 1235,710.003977 C1235,613.354814 1156.64983,535.002558 1060,535.002558 Z",
    id: "Shape",
    fill: "#FB6340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoaching);
export default __webpack_public_path__ + "static/media/coaching.2272c18de093d4bb9c1477e9d5808a92.svg";
export { ForwardRef as ReactComponent };